import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const interests = ["Hospitality", "Commercial", "Residential", "Other"];

const budgets = [
  "Under AED 500k",
  "AED 500k – 2M",
  "AED 2M – 5M",
  "Prefer to discuss",
];

const Enquiry = () => {
  const [selected, setSelected] = useState<string[]>([]);
  const [budget, setBudget] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const toggleInterest = (interest: string) =>
    setSelected((prev) =>
      prev.includes(interest)
        ? prev.filter((i) => i !== interest)
        : [...prev, interest]
    );

  const buildMessage = () => {
    const parts = [
      `Hello H Projects, my name is ${name || "..."}.`,
      selected.length ? `I'm interested in: ${selected.join(", ")}.` : "",
      budget ? `Budget: ${budget}.` : "",
      phone ? `Phone: ${phone}` : "",
      message,
    ];
    return parts.filter(Boolean).join("\n");
  };

  const sendWhatsApp = () => {
    window.open(
      `https://wa.me/971585864996?text=${encodeURIComponent(buildMessage())}`,
      "_blank"
    );
  };

  const sendEmail = () => {
    window.location.href = `mailto:Projects@HProjects.me?subject=${encodeURIComponent(
      "Project enquiry"
    )}&body=${encodeURIComponent(buildMessage())}`;
  };

  const inputStyle =
    "bg-h-navy border border-h-gold rounded p-3 text-h-gold placeholder-h-gold placeholder-opacity-50 w-full focus:outline-none focus:border-2";

  return (
    <section id="enquiry" className="pt-10">
      <div className="max-w-3xl mx-4 sm:mx-auto pb-16">
        <h3 className="mt-2 pb-4 text-4xl lg:text-6xl font-normal uppercase tracking-[0.2em] text-h-gold text-center">
          Start Your Project
        </h3>
        <p className="text-h-gold text-center pb-8">
          Tell us a little about what you have in mind and we will come straight
          back to you.
        </p>

        <div className="bg-h-navy border border-h-gold rounded-lg p-6 sm:p-10">
          <p className="text-h-gold uppercase tracking-[0.15em] text-sm pb-3">
            I'm interested in
          </p>
          <div className="flex flex-wrap gap-4 pb-8">
            {interests.map((interest) => (
              <label
                key={interest}
                className="flex items-center gap-2 text-h-gold cursor-pointer select-none"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(interest)}
                  onChange={() => toggleInterest(interest)}
                  className="w-4 h-4 accent-[#D2A86A]"
                />
                {interest}
              </label>
            ))}
          </div>

          <p className="text-h-gold uppercase tracking-[0.15em] text-sm pb-3">
            Project budget
          </p>
          <select
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
            className={`${inputStyle} mb-8`}
          >
            <option value="">Select a range (optional)</option>
            {budgets.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>

          <p className="text-h-gold uppercase tracking-[0.15em] text-sm pb-3">
            Your name
          </p>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name"
            className={`${inputStyle} mb-8`}
          />

          <p className="text-h-gold uppercase tracking-[0.15em] text-sm pb-3">
            Phone number
          </p>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="So we can call you straight back"
            className={`${inputStyle} mb-8`}
          />

          <p className="text-h-gold uppercase tracking-[0.15em] text-sm pb-3">
            Anything else?
          </p>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Location, timeline, the vision..."
            rows={3}
            className={`${inputStyle} mb-8`}
          />

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={sendWhatsApp}
              className="flex items-center justify-center gap-2 bg-h-gold text-h-navy font-bold py-3 px-6 rounded hover:opacity-80 w-full"
            >
              <FaWhatsapp size={20} /> Send via WhatsApp
            </button>
            <button
              onClick={sendEmail}
              className="bg-h-navy text-h-gold border border-h-gold font-bold py-3 px-6 rounded hover:opacity-80 w-full"
            >
              Send by email
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Enquiry;
